<mp-shell
  #shellComponent
  [appTitle]="(appTitle$ | async) ?? ''"
  [showAppLogo]="(showAppLogo$ | async) ?? false"
  [(isOpened)]="isSideNavOpened"
>
  <mp-navigation-profile path="/profile" [size]="profileSize()" (logout)="logout()">
    <mpauth-profile-display [profile]="profile()" [size]="profileSize()" />

    @if (hasProfileMultipleAvailableOrganizations()) {
      <button
        mat-menu-item
        [routerLink]="['active-organization-selection']"
        [mpAppInsightsEvent]="CoreInsightsEvent.ACCOUNT_MANAGEMENT_BUTTON_SWITCH_ORGANIZATION"
        [includePageNameInEvent]="false"
      >
        <mat-icon>swap_horiz</mat-icon>
        <span>Organisation wechseln</span>
      </button>
    }
  </mp-navigation-profile>

  @if (!isSideNavOpened()) {
    <div class="navigation-menu-items-separator">
      <mat-divider class="navigation-menu-items-separator__divider" />
    </div>
  }

  <div class="navigation-menu-items" [class]="{ 'navigation-menu-items--collapsed': !isSideNavOpened() }">
    <mp-navigation-group
      [navigationGroup]="{ route: '/', icon: 'home', label: 'Start' }"
      [isExpanded]="isSideNavOpened()"
    />

    @for (navigationItem of navigationStructure(); track $index) {
      <mp-navigation-group
        [navigationGroup]="navigationItem"
        [isExpanded]="isSideNavOpened()"
        [sideNavRef]="shellComponent.sideNavRef()"
      />
    }
  </div>

  @if (!isSideNavOpened() && hasHelperFunctions) {
    <div class="navigation-menu-items-separator">
      <mat-divider class="navigation-menu-items-separator__divider" />
    </div>
  }

  <mp-helper-links-container
    class="navigation-menu-items__helper-links-container"
    sidebar-end-element
    [isSmall]="!isSideNavOpened()"
    (hasHelperFunctions)="hasHelperFunctions = $event"
  />
</mp-shell>
